import React from "react";
import PropTypes from "prop-types";
import { Icon, Typography } from "@material-ui/core";
import useStyles from "./styles";

const PageHeader = ({ title, icon, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <div className={classes.headerContent}>
        <div className={classes.titleContainer}>
          <Icon fontSize="large" className={classes.icon}>
            {icon}
          </Icon>
          <Typography variant="h4" color="textSecondary" className={classes.pageTitle}>
            {title}
          </Typography>
        </div>
        {children}
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  children: PropTypes.node
};

export default React.memo(PageHeader);
